import { PLAYER_SIZE } from '../../constants';

/**
 * Block shield SVG — 50 px overlay centred on the player sprite.
 * Rendered only while the player's shieldUntil window is active.
 */
export function PlayerShield() {
  return (
    <svg
      className="player-shield-svg"
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        position:      'absolute',
        left:          PLAYER_SIZE / 2 - 25,
        top:           PLAYER_SIZE / 2 - 25,
        pointerEvents: 'none',
      }}
    >
      {/* Outer glow ring */}
      <ellipse cx="25" cy="26" rx="20" ry="23"
        fill="rgba(100,180,255,0.18)" stroke="#88ccff" strokeWidth="1.5" />
      {/* Main shield body */}
      <path d="M25 5 L42 14 L42 28 Q42 42 25 47 Q8 42 8 28 L8 14 Z"
        fill="url(#shieldGrad)" stroke="#aaddff" strokeWidth="1.8" strokeLinejoin="round" />
      {/* Inner highlight stripe */}
      <path d="M25 10 L38 18 L38 28 Q38 38 25 43 Q12 38 12 28 L12 18 Z"
        fill="rgba(180,220,255,0.12)" stroke="rgba(200,235,255,0.35)"
        strokeWidth="1" strokeLinejoin="round" />
      {/* Cross emblem */}
      <rect x="22.5" y="18"  width="5"  height="16" rx="1.5" fill="rgba(180,230,255,0.65)" />
      <rect x="17"   y="22.5" width="16" height="5"  rx="1.5" fill="rgba(180,230,255,0.65)" />
      <defs>
        <radialGradient id="shieldGrad" cx="35%" cy="30%" r="65%">
          <stop offset="0%"   stopColor="#c8e8ff" stopOpacity="0.95" />
          <stop offset="60%"  stopColor="#4499dd" stopOpacity="0.80" />
          <stop offset="100%" stopColor="#1155aa" stopOpacity="0.90" />
        </radialGradient>
      </defs>
    </svg>
  );
}
